// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".edit-lock[data-v-70b5454e]{top:-20px}.mdi-square[data-v-70b5454e]{font-size:14px!important;margin-right:5px}.mdi-information[data-v-70b5454e]{position:absolute;right:20px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
